import { useAuthContext } from '../contexts/AuthContext';

/**
 * Shown when a user has a valid Keycloak session but no provisioned AMS
 * account — `account_id` is absent from the token (or `ams_status` is
 * `not_provisioned`), so every account-scoped API call returns 403. This is
 * the case for users created outside the normal registration flow (e.g. the
 * Keycloak seed job). It offers the only meaningful action: sign out.
 *
 * Styled to match the full-screen centered states in AuthGate (App.tsx).
 */
export default function AccountNotProvisioned() {
  const { logout } = useAuthContext();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
      <div className="flex flex-col items-center gap-4 max-w-md text-center p-6">
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-amber-100 dark:bg-amber-900/30">
          <svg
            className="h-6 w-6 text-amber-600 dark:text-amber-400"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.8}
            stroke="currentColor"
            aria-hidden="true"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v3.75m9-.75a9 9 0 11-18 0 9 9 0 0118 0zm-9 3.75h.008v.008H12v-.008z"
            />
          </svg>
        </div>
        <h1 className="text-xl font-semibold text-gray-900 dark:text-white">
          Your account isn&apos;t set up yet
        </h1>
        <p className="text-sm text-gray-600 dark:text-gray-400">
          Your login was created but your account hasn&apos;t been fully
          configured. Contact your administrator or try again later.
        </p>
        <button
          onClick={logout}
          className="mt-2 px-4 py-2 bg-indigo-600 text-white rounded-md text-sm hover:bg-indigo-700 transition-colors"
        >
          Sign out
        </button>
      </div>
    </div>
  );
}
